import createEntityBundle from '~/src/Lib/createEntityBundle'
import { WasteReasonPlantBatch as schema } from '~/src/Store/Schemas'

const name = 'wasteReasonPlantBatches'

export default createEntityBundle({
  name,
  apiConfig: {
    schema,
  },
})
